<template>
    <b-modal id="update-email"
        title="Update your email"
        @cancel="clearDetails"
        ref="updateEmail"
        centered
        hide-footer>
        <p>{{ didSendCode ? 'Enter the verification code sent to your updated email address.' : 'A verification code will be sent to your updated email address.' }}</p>
        <div class="row">
            <div class="col">
                <div class="form-group" v-if="!didSendCode">
                    <label class="sr-only" for="email">Enter Email</label>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <i class="far fa-envelope input-icon px-1"></i>
                            </div>
                        </div>
                        <input v-model="email" v-on:input="$v.email.$touch" id="code" name="token" :class="{'is-invalid': $v.email.$error, 'is-valid': $v.email.$dirty && !$v.email.$invalid}" type="email" class="form-control form-control-lg p-4" placeholder="Enter email" dusk="two-factor-code" required autofocus>
                    </div>
                    <!-- Validations -->
                    <small v-show="!$v.email.$dirty" class="text-muted">* Required</small><!-- default message -->
                    <small v-show="$v.email.$dirty && !$v.email.$invalid" class="text-muted">&nbsp;</small><!-- Stop input jumping -->
                    <small v-show="!$v.email.required && $v.email.$dirty" class="text-danger">* Required</small><!-- Required -->
                    <small v-show="$v.email.$error && $v.email.required" class="text-danger">This is not a valid email</small><!-- Error -->
                </div>
                <div class="form-group" v-if="didSendCode">
                    <label class="sr-only" for="email">Verification Code</label>
                    <div class="input-group mb-2">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <i class="far fa-envelope input-icon px-1"></i>
                            </div>
                        </div>
                        <input v-model="token" id="code" name="token" class="form-control form-control-lg p-4" autocomplete="off" placeholder="Verification Code" dusk="two-factor-code" required autofocus>
                    </div>
                    <small class="text-muted">&nbsp;</small>
                </div>
            </div>
        </div>
        <div class="row text-right">
            <div class="col">
                <button type="button" @click.prevent="closeModal()" class="btn btn-link">Cancel</button>
                <button type="submit" @click.prevent="didClick()" :disabled="disableSubmit" dusk="two-factor-button" :class="buttonClass" class="btn btn-lg p-4">{{buttonLabel}} <i v-if="loading" class="far fa-spinner-third fa-spin"></i></button>
            </div>
        </div>
    </b-modal>

</template>
<script>
import { required, email } from 'vuelidate/lib/validators';
export default {
    data() {
        return {
            email: '',
            token: '',
            loading: false,
            didSendCode: false,
            buttonLabel: 'Verify Email',
            verificationAttempts: 0,
            maxVerificationAttempts: 3,
            error:{
                message:''
            },
            isUpdating: {
                profile: false
            },
            processing: false,
        }
    },
    validations: {
        email: {required, email}
    },
    computed: {
        remainingVerificationAttempts(){
            return this.maxVerificationAttempts - this.verificationAttempts;
        },
        readyToSubmit() {
            (($v.email.$invalid && $v.email.$dirty) || (!$v.email.dirty && this.email.length == 0)) || this.loading
            return !this.$v.$invalid ? 'success' : 'light';
        },
        disableOk() {
            return this.$v.$invalid;
        },
        disableSubmit() {
            if(this.didSendCode) {
                return this.token.length > 4 && !this.processing ? false : true;
            } else {
                return ((this.$v.email.$invalid && this.$v.email.$dirty) || (!this.$v.email.dirty && this.email.length == 0)) || this.loading;
            }
        },
        buttonClass() {
            if(this.didSendCode) {
                return this.token.length > 4 ? 'btn-success' : 'btn-light';
            } else {
                if((this.$v.email.$invalid && this.$v.email.$dirty) || (!this.$v.email.dirty && this.email.length == 0)) {
                    return 'btn-light';
                } else {
                    return 'btn-success';
                }
            }
        },
    },
    methods:{
        didClick(){
            this.error = '';
            this.didSendCode ? this.attemptVerification() : this.requestVerificationCode()
        },
        closeModal() {
            this.$refs['updateEmail'].hide();
        },
        clearDetails(){
            this.email = '';
            this.$v.$reset();
        },
        requestVerificationCode(){

            /** Ensure they aren't entering the same email */
            if(this.email == this.userDetails.email) {
                this.$swal({
                    type:'error',
                    title: 'That is your current email address!',
                    showConfirmButton: false,
                    timer: 3000
                });
                return;
            }

            this.loading = true;
            this.buttonLabel = 'Sending Code'
            this.requestTwoFactorCode({two_factor_method: 'email', two_factor_details: this.email })
                .then((response) => {
                    this.buttonLabel = 'Verify Code'
                    this.title = 'Enter Verification Code'
                    this.didSendCode = true
                    this.loading = false
                })
                .catch((error) => {
                    this.loading = false
                    this.resetPage()
                    this.error = error.response.data.message
                });

        },
        attemptVerification(){
            if(!this.token){
                return this.error = 'Please enter your verification code'
            }
            this.processing = true;

            this.verificationAttempts++;

            this.loading = true;
            this.buttonLabel = 'Verifying Code';
            this.sendTwoFactorResponse({token: this.token, two_factor_method: 'email', two_factor_details: this.email})
                .then((response) => {
                    this.updateEmail();
                })
                .catch((error) => {
                    this.loading = false;
                    this.processing = false;

                    if(error.response.status === 410) {
                        this.$swal({
                            toast: true,
                            type:'error',
                            title: 'This verification token has expired. Please try again.',
                            showConfirmButton: false,
                            timer: 3000,
                            onClose: () => {
                                window.location.reload();
                            }
                        });
                        return;
                    }

                    if(this.verificationAttempts > 2){
                       return window.location = '/account/account-summary';
                    }
                    this.$swal({
                        type:'error',
                        title: 'Verification code does not match. You have '+this.remainingVerificationAttempts+' attempts left.',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.buttonLabel = 'Verify Code';
                });
        },
        resetPage(){
            this.didSendCode = false;
            this.buttonLabel = 'Send Code';
        },
        updateEmail() {
            this.buttonLabel = 'Updating Email';
            this.updateUserEmail({email: this.email})
                .then((response) => {
                    /** Update email in vuex */
                    this.$store.commit('setUserField', ['email', this.email]);
                    /** Update parent form property */
                    this.$parent.form.email = this.email;
                    /** Hide form */
                    this.$store.commit('setDisplayEmailUpdateForm', false);
                    /** Show success */
                    this.$swal({
                        type:'success',
                        title: 'Email Updated',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    /** reload page */
                    return window.location = '/account/account-summary';
                })
                .catch((error) => {
                    this.loading = false;
                    this.resetPage()
                    this.$swal({
                        type:'error',
                        title: error.response.data.errors.email[0],
                        timer: 3000
                    });
                }).then(() => this.processing = false);
        },
    }
}
</script>
<style>
</style>
